/* unplugin-vue-components disabled */import script from "./assignTask.vue?vue&type=script&setup=true&lang=js"
export * from "./assignTask.vue?vue&type=script&setup=true&lang=js"

import "./assignTask.vue?vue&type=style&index=0&id=6083f7e1&lang=scss"

const __exports__ = script;

export default __exports__